<template>
  <div v-if="showFoxCoinsAdd" class="foxcoins-add">
    <span>{{ getLabelText }}</span>
    <span class="foxcoins-pay">&nbsp;+{{ foxCoinsAddCount }}</span>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'
  import BasketStatus from '@/models/enums/BasketStatus'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'FoxCoinAddLabel',
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        order: state => state.orders.currentEditOrder,
      }),
      showFoxCoinsAdd () {
        return this.foxCoinsAddCount > 0 && !this.hasFoxCoinsPay
      },
      isNewOrderCreateInProgress () {
        return this.basket && this.basket.status === BasketStatus.inProcess
      },
      foxCoinsAddCount () {
        return this.basket ? this.basket.foxCoinsAdd : 0
      },
      hasFoxCoinsPay () {
        return this.basket &&
          this.basket.promocode &&
          this.basket.promocode.promoCode &&
          this.basket.promocode.promoCode.action === PromoCodeAction.FoxCoinPay
      },
      getLabelText () {
        if (!this.isNewOrderCreateInProgress &&
          this.order &&
          this.order.orderStatus === OrderStatus.Completed &&
          this.order.isFoxCoinsAdded) {
          return 'Начислено Сеткоинов'
        }
        return 'Будет начислено Сеткоинов'
      },
    },
  }
</script>

<style lang="less" scoped>
.foxcoins-add {
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: -20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;

  .foxcoins-pay {
    font-size: 16px;
    color: #fe9923;
    display: flex;
    align-items: center;
    line-height: 1.2;
    font-weight: bold;

    &:after {
      display: inline-block;
      height: 20px;
      width: 20px;
      content: '';
      background: url("/img/icons/setcoins-icon.svg") no-repeat center center;
      background-size: contain;
      margin-left: 2px;
      margin-top: -3px;
    }
  }
}

</style>
